import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProceduresListComponent } from './procedures-list.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { ProfileProceduresPipesModule } from '../+profile/subcomponent/profile-procedures/pipes/profile-procedures.pipes.module';
import { GtmModule } from '../../directives/gtm/gtm.module';
import { DlsPaginationModule } from '@zelis/dls/pagination';
import { DlsButtonModule } from '@zelis/dls/button';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    TranslateModule,
    ProfileProceduresPipesModule,
    DlsPaginationModule,
    RouterModule,
    GtmModule,
    DlsButtonModule,
  ],
  declarations: [ProceduresListComponent],
  exports: [ProceduresListComponent],
  providers: [],
})
export class ProceduresListModule {}
